











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BaseMultilineTextInput>({
    model: {
        prop: 'value',
        event: 'input'
    }
})
export default class BaseMultilineTextInput extends Vue {
    @Prop({ type: String, required: true })
    public readonly value!: string

    @Prop({ type: String, required: false, default: '65' })
    public readonly cols!: string

    @Prop({ type: String, required: false, default: '5' })
    public readonly rows!: string

    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean

    @Prop({ type: Boolean, required: false, default: false })
    public readonly blurOnNewLine!: boolean

    public onInput(event) {
        if (this.blurOnNewLine) {
            if (event.inputType === 'insertLineBreak') {
                event.target.blur()
            }
        }
        this.$emit('input', event.target.value)
    }
}
